// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.partner_partnersSection__pvGgc {
  background-color: #edf0f0;
  padding: 3em 5em;
  width: 100%;
}

.partner_partnersCarouselContainer__dz3lI {
  max-width: 1000px;
  margin: 0 auto;
  overflow: hidden;
}

.partner_partnersCarousel__1IL\\+5 {
  display: flex;
  transition: transform 0.5s ease;
  width: 100%;
}

.partner_brandItem__spM-5 {
  flex: 0 0 auto;
  margin: 0 20px;
  width: auto;
  display: flex;
  justify-content: center;
}

.partner_brandItem__spM-5 img {
  filter: grayscale(100%);
  transition: filter 0.3s ease-in-out;
  width: 100%;
  max-width: 120px; /* Set a max width for consistency */
  height: auto;
  vertical-align: top;
}

.partner_brandItem__spM-5 img:hover {
  filter: grayscale(0%);
}

@media (max-width: 768px) {
  .partner_brandItem__spM-5 {
    width: calc(100% / 4);
    margin: 0 10px;
  }

  .partner_brandItem__spM-5 img {
    max-width: 80px;
  }

  .partner_partnersCarouselContainer__dz3lI {
    max-width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/PAGES/HOME_PAGE/SECTIONS/PARTNERS/partner.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,cAAc;EACd,cAAc;EACd,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,mCAAmC;EACnC,WAAW;EACX,gBAAgB,EAAE,oCAAoC;EACtD,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".partnersSection {\n  background-color: #edf0f0;\n  padding: 3em 5em;\n  width: 100%;\n}\n\n.partnersCarouselContainer {\n  max-width: 1000px;\n  margin: 0 auto;\n  overflow: hidden;\n}\n\n.partnersCarousel {\n  display: flex;\n  transition: transform 0.5s ease;\n  width: 100%;\n}\n\n.brandItem {\n  flex: 0 0 auto;\n  margin: 0 20px;\n  width: auto;\n  display: flex;\n  justify-content: center;\n}\n\n.brandItem img {\n  filter: grayscale(100%);\n  transition: filter 0.3s ease-in-out;\n  width: 100%;\n  max-width: 120px; /* Set a max width for consistency */\n  height: auto;\n  vertical-align: top;\n}\n\n.brandItem img:hover {\n  filter: grayscale(0%);\n}\n\n@media (max-width: 768px) {\n  .brandItem {\n    width: calc(100% / 4);\n    margin: 0 10px;\n  }\n\n  .brandItem img {\n    max-width: 80px;\n  }\n\n  .partnersCarouselContainer {\n    max-width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"partnersSection": `partner_partnersSection__pvGgc`,
	"partnersCarouselContainer": `partner_partnersCarouselContainer__dz3lI`,
	"partnersCarousel": `partner_partnersCarousel__1IL+5`,
	"brandItem": `partner_brandItem__spM-5`
};
export default ___CSS_LOADER_EXPORT___;
